export const slugify = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^-|-$/, '')
}

export const trimSlashes = (str: string) => {
  return str.replace(/^\/|\/$/g, '')
}

export const isNumeric = (v: number | string): v is number | `${number}` =>
  !isNaN(Number(v))
